import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import storage from 'redux-persist/lib/storage';
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import {paylogikApi} from '../rtkquery/swaggerWontGen';
import invoiceResearchReducer from './invoiceresearchSlice';
import invoiceEntryLaunchReducer from './invoiceEntryLaunchSlice';
import authReducer from './authSlice';
import carrierAdminReducer from './carrierAdminSlice';
import customerAdminReducer from './customerAdminSlice';
import feesAppRuleReducer from './feesAppRuleSlice';
import reportingReducer from './reportingSlice';
import LogRocket from 'logrocket';
import {errorMiddleware} from '../middleware/errorMiddleware';

const reducers = combineReducers({
    [paylogikApi.reducerPath]: paylogikApi.reducer,
    invoiceresearch: invoiceResearchReducer,
    invoiceEntryLaunch: invoiceEntryLaunchReducer,
    carrierAdmin: carrierAdminReducer,
    customerAdmin: customerAdminReducer,
    feesAppRules: feesAppRuleReducer,
    auth: authReducer,
    reporting: reportingReducer,
});

export const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['api'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(paylogikApi.middleware)
            .concat(errorMiddleware) // Add error middleware AFTER RTK Query middleware
            .concat(LogRocket.reduxMiddleware()),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
